import React from 'react';
import PropTypes from 'prop-types';
import {
  Navbar,
} from 'react-bootstrap';

import NavBarBrand from './NavBarBrand';

const NavBarWithToggle = (props) => {
  const { children, showToggle, onSwitchToggle } = props;
  return (
    <Navbar sticky="top" bg="dark" variant="dark" expand="lg">
      <NavBarBrand />
      <Navbar.Toggle aria-controls="toggle-navbar-nav" aria-expanded={showToggle} onClick={onSwitchToggle} />
      <Navbar.Collapse id="toggle-navbar-nav" in={showToggle}>
        {children}
      </Navbar.Collapse>
    </Navbar>
  );
};

NavBarWithToggle.propTypes = {
  showToggle: PropTypes.bool.isRequired,
  onSwitchToggle: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

NavBarWithToggle.defaultProps = {
  children: undefined,
};

export default NavBarWithToggle;
